import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Page wrapper - the single source of truth for page width + padding inside the shell.
 *
 * Every page gets the SAME cap and is centred, so content edges line up regardless of
 * which page you're on or whether the sidebar is expanded or collapsed to the rail.
 * Don't reintroduce per-page `max-w-*` overrides: in the Frontline app that left a
 * growing dead gutter on the right and gave tabs a different right edge than the
 * content under them.
 *
 * 1440px is wide enough that the data-dense tables here (the employee directory and
 * the calibration grid are the widest) never scroll at realistic desktop sizes.
 */
export function PageContainer({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<'main'>) {
  return (
    <main
      className={cn('mx-auto w-full min-w-0 max-w-[1440px] space-y-6 p-4 sm:p-6 md:p-8', className)}
      {...props}
    >
      {children}
    </main>
  );
}
